export default "__VITE_ASSET__DbpJ0NIN__"